import { render, staticRenderFns } from "./EventLiveDonatedItemList.vue?vue&type=template&id=202de23e&scoped=true&"
import script from "./EventLiveDonatedItemList.vue?vue&type=script&lang=js&"
export * from "./EventLiveDonatedItemList.vue?vue&type=script&lang=js&"
import style0 from "./EventLiveDonatedItemList.vue?vue&type=style&index=0&id=202de23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202de23e",
  null
  
)

export default component.exports